<template>
	<div>
		<svg id="room" :viewBox="viewBoxString" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xhtml="http://www.w3.org/1999/xhtml">
            <!-- room image -->
            <!--<image href="@/../static/EmptyRoom2.png" width="800px" x="-400px" y="-250px"></image>
			-->

			<defs>
				<filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
					<feOffset result="offOut" in="SourceAlpha" dx="0" dy="5" />
					<feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
					<feComponentTransfer result="alphaOut" in="blurOut">
						<feFuncA type="linear" slope="0.2"/>
					</feComponentTransfer>
					<feBlend in="SourceGraphic" in2="alphaOut" mode="normal" />
				</filter>
				<filter id="select" x="-20%" y="-20%" width="140%" height="140%">
					<feOffset result="sourceOut" in="SourceGraphic" dx="0" dy="0" />
					<feGaussianBlur result="blurOut" in="sourceOut" stdDeviation="5" />
					<feComponentTransfer result="alphaOutGlow" in="blurOut">
						<feFuncA type="linear" slope="0.8"/>
					</feComponentTransfer>

					<feOffset result="offOut" in="SourceAlpha" dx="0" dy="0" />
					<feComponentTransfer result="alphaOut" in="offOut">
						<feFuncA type="linear" slope="0.2"/>
					</feComponentTransfer>
					<feBlend result="blendOne" in="alphaOut" in2="SourceGraphic" mode="normal" />
					<feBlend in="blendOne" in2="alphaOutGlow" mode="normal" />
				</filter>
				<pattern id="pattern2" x="0" y="0" width="128" height="128" patternUnits="userSpaceOnUse" >
					<image xlink:href="@/../static/wood5.jpg" x="0" y="0" width="128" height="128"></image>
				</pattern>
			</defs>

			<g> <!-- :filter="!viewBoxAnimating ? 'url(#shadow)' : ''"-->
				<!--<g v-for="rect in getRoom">
					<rect  :x="rect.x" :y="rect.y" :width="rect.width" :height="rect.height" rx="10" stroke="#FF8A00" style="stroke-width:3px" fill="#FFF5E5"></rect>
					<foreignObject class="room-header" :x="rect.x" :y="rect.y-30" :width="rect.width" :height="30">
						<span class="room-name">{{ rect.name }}</span>
					</foreignObject>
				</g>-->
				<Room v-for="room in getRooms" :key="room.id" :metadata="room" />
			</g>

			<!-- objects -->
			<!-- <Boombox :x="-315" :y="-140" /> -->
			<Object v-for="object in sortedObjects" :key="object.id" v-if="object != undefined" :metadata="object" />
            
            <!-- people -->
            <Person v-for="peer in getPeers" :metadata="peer" />
			<Person :metadata="getSelf" :isself="true" />

			<ContextMenu />
		</svg>
		<Interface/>
	</div>
</template>

<script>
import Person from "@/components/Person";
import Room from "@/components/Room";
// import Boombox from "@/components/Boombox";
import ObjectElement from "@/components/Object";
import Interface from "@/components/Interface";
import ContextMenu from "@/components/ContextMenu";

import Vue from 'vue';
import { mapGetters } from "vuex";

import { distance } from "@/utils";

export default {
	name: "Main",
	computed: {
		...mapGetters(["getSelf", "getPeers", "getObjects", "getRooms", "view"]),
		viewBoxString () {
			// center svg on [0, 0]
			return `${-this.width/2 + this.offset.x} ${-this.height/2 + this.offset.y} ${this.width} ${this.height}`
		},
		sortedObjects() {
            return this.getObjects.slice().sort((a,b) => a.z_index - b.z_index)
        },
	},
	data: function() {
		return {
			width: 0,
			height: 0,
			offset: {
				x: 0,
				y: 0
			},
			targetOffset: {
				x: 0,
				y: 0
			},
			viewBoxAnimating: false,
			lastFrame: 0
		}
	},
	mounted() {
		window.addEventListener('resize', this.getWindowSize);
		//window.scrollTo(0,1);

		window.addEventListener('mouseup', this.releaseSelf);
		window.addEventListener('touchend', this.releaseSelf);
        
		this.getWindowSize();

		this.lastFrame = Date.now();
		this.updateLoop();
	},
	methods: {
		getWindowSize() {
			this.width = document.documentElement.clientWidth;
			this.height = document.documentElement.clientHeight;

			// this.view.width = this.width;
			// this.view.height = this.height;

			//Vue.set(this.view, 'width', this.width)
			//Vue.set(this.view, 'height', this.height)

			this.$store.commit('setView', {
				width: this.width,
				height: this.height
			})
		},
		releaseSelf() {
			if(distance(this.targetOffset, this.getSelf) > 100) {
				this.targetOffset.x = this.getSelf.x;
				this.targetOffset.y = this.getSelf.y;
			}
		},
		updateLoop() {
			window.requestAnimationFrame(this.updateLoop);

			let dt = Date.now() - this.lastFrame;
			this.lastFrame = Date.now();

			if(this.targetOffset.x != this.offset.x) {
				this.viewBoxAnimating = true;

				let prevOffsetX = this.offset.x;
				let prevOffsetY = this.offset.y;

				let dx = (this.targetOffset.x - this.offset.x)*(dt/1000);
				let dy = (this.targetOffset.y - this.offset.y)*(dt/1000);

				this.offset.x += dx;
				this.offset.y += dy;
				this.offset.x = Math.round(this.offset.x)
				this.offset.y = Math.round(this.offset.y)

				this.$store.commit('setView', {
					x: this.offset.x,
					y: this.offset.y
				})

				//Vue.set(this.view, 'x', Math.round(this.view + dx))
				//Vue.set(this.view, 'y', Math.round(this.view + dx))

				if(this.offset.x === prevOffsetX && this.offset.y === prevOffsetY) {
					this.targetOffset.x = this.offset.x;
					this.targetOffset.y = this.offset.y;
					this.viewBoxAnimating = false;
				}
			}
		}
	},
	components: {
		Person,
		// Boombox,
		'Object': ObjectElement,
		Interface,
		ContextMenu,
		Room
	}
};
</script>

<style>
    #room > image {
        pointer-events: none;
    }

	svg {
		transition: all .5s ease-out;
	}
	
</style>
